
<template>
  <div class="cbody1">
      
      <div class="userbody">
          <div class="left">
               <div class="box1">
                    <div class="userimg">
                      <svg data-bbox="0 0 50 50" data-type="shape" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 50 50"><g><path d="M25 48.077c-5.924 0-11.31-2.252-15.396-5.921 2.254-5.362 7.492-8.267 15.373-8.267 7.889 0 13.139 3.044 15.408 8.418-4.084 3.659-9.471 5.77-15.385 5.77m.278-35.3c4.927 0 8.611 3.812 8.611 8.878 0 5.21-3.875 9.456-8.611 9.456s-8.611-4.246-8.611-9.456c0-5.066 3.684-8.878 8.611-8.878M25 0C11.193 0 0 11.193 0 25c0 .915.056 1.816.152 2.705.032.295.091.581.133.873.085.589.173 1.176.298 1.751.073.338.169.665.256.997.135.515.273 1.027.439 1.529.114.342.243.675.37 1.01.18.476.369.945.577 1.406.149.331.308.657.472.98.225.446.463.883.714 1.313.182.312.365.619.56.922.272.423.56.832.856 1.237.207.284.41.568.629.841.325.408.671.796 1.02 1.182.22.244.432.494.662.728.405.415.833.801 1.265 1.186.173.154.329.325.507.475l.004-.011A24.886 24.886 0 0 0 25 50a24.881 24.881 0 0 0 16.069-5.861.126.126 0 0 1 .003.01c.172-.144.324-.309.49-.458.442-.392.88-.787 1.293-1.209.228-.232.437-.479.655-.72.352-.389.701-.78 1.028-1.191.218-.272.421-.556.627-.838.297-.405.587-.816.859-1.24a26.104 26.104 0 0 0 1.748-3.216c.208-.461.398-.93.579-1.406.127-.336.256-.669.369-1.012.167-.502.305-1.014.44-1.53.087-.332.183-.659.256-.996.126-.576.214-1.164.299-1.754.042-.292.101-.577.133-.872.095-.89.152-1.791.152-2.707C50 11.193 38.807 0 25 0"></path></g></svg>
                    </div>
                    <div class="username">
                       {{userdata.name==''?'你好': userdata.name}}
                    </div>
               </div>
               <div class="box2">
                  <router-link v-for="item in usernav" :to="item.path" :key="item.title" class="nav" >{{item.title}}</router-link>
               </div>
          </div>

          <div class="right">
             <div class="edbox">
                  <p class="p1">Account</p>
                  <p class="p2">View and edit your personal info below.</p>
                  <p class="p3">Update your personal information.</p>
                  <div class="usercbox">
                    <div class="line">
                         <p class="pti">Name</p>
                         <input type="text" v-model="cguser.name" class="input1">
                     </div>
                     <div class="line">
                         <p class="pti">Telphone</p>
                         <input type="text" v-model="cguser.telphone" class="input1" disabled>
                     </div>
                     <div class="line">
                         <p class="pti">Password</p>
                         <input type="password" v-model="cguser.password" class="input1" >
                     </div>

                     
                  </div>
                  <div class="gocg" @click="cg()">Update Info</div>
             </div>
          </div>
      </div>
  </div>
</template>

<script>
import { order,edtUser} from '../../api/userMG'


export default {
  name:'index',
  data() {
    return {
      huaimg:require("@/assets/img/hua4.png"),
     
      listData:[],
      userdata : JSON.parse(localStorage.getItem('userdata')) ,
      cguser:{
        id:JSON.parse(localStorage.getItem('userdata')).id,
        name:JSON.parse(localStorage.getItem('userdata')).name,
        telphone:JSON.parse(localStorage.getItem('userdata')).telphone,
        password:''
      },
      usernav:[
      {
        title:'My Bookings',
        path:'/user/Bookings',

      },
      {
        title:'My Account',
        path:'/user/Index',

      }]
    }
  },
  // 註冊組件
  components: {
   

    
  },
  /**
   * 數據發生改變
   */

  /**
   * 創建完畢
   */
  created() {
   
  },
  mounted() {

},
  /**
   * 裏麵的方法隻有被調用才會執行
   */
  methods: {

    cg(){
       if(this.cguser.name!=''){

        edtUser(this.cguser)
        .then(res => {
          this.loading = false
    
          if (res.code != 1) {
            this.$message({
              type: 'info',
              message: res.data.message
            })
          } else {
            this.userdata.name=this.cguser.name
            localStorage.setItem('userdata', JSON.stringify(this.userdata))
            this.$message({
              message: '修改成功',
              type: 'success'
            })
                
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('修改失敗，請稍後再試！')
        })
       }else{
        this.$message({
              type: 'info',
              message: '請填寫用戶名！'
            })
       }


    }
   

   
  }
}
</script>


 
 


// WEBPACK FOOTER //
// src/views/user/Index.vue